// indices-by-asset-class-page.component.ts
// Vendor libraries
import { ElementRef } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "../../../../../../../../search/static/search/ts/features/base-autocomplete/components/base-autocomplete.component";
import * as i2 from "@angular/common";
import * as i3 from "@angular/router";
function BrowseIndexFamiliesPageComponent_ng_container_34_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "a", 29);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const letter_r1 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("fragment", letter_r1.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(letter_r1.key);
} }
function BrowseIndexFamiliesPageComponent_ng_container_38_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "a", 33)(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const family_r2 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("href", "/indices/families/", family_r2, "", i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", family_r2, " ");
} }
function BrowseIndexFamiliesPageComponent_ng_container_38_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 30)(2, "div", 31);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 32);
    i0.ɵɵtemplate(5, BrowseIndexFamiliesPageComponent_ng_container_38_ng_container_5_Template, 4, 3, "ng-container", 26);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const familyGroup_r3 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵattribute("id", familyGroup_r3.key);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(familyGroup_r3.key);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", familyGroup_r3.value);
} }
export class BrowseIndexFamiliesPageComponent {
    constructor(eltRef) {
        this.eltRef = eltRef;
        this.menuItems = {
            A: 'A',
            B: 'B',
            C: 'C',
            D: 'D',
            E: 'E',
            F: 'F',
            G: 'G',
            H: 'H',
            I: 'I',
            J: 'J',
            K: 'K',
            L: 'L',
            M: 'M',
            N: 'N',
            O: 'O',
            P: 'P',
            Q: 'Q',
            R: 'R',
            S: 'S',
            T: 'T',
            U: 'U',
            V: 'V',
            W: 'W',
            X: 'X',
            Y: 'Y',
            Z: 'Z',
        };
        this.familyData = {};
        this.familyData = JSON.parse(this.eltRef.nativeElement.getAttribute('indexFamilies'));
    }
    ngOnInit() {
        this.updateLetterSections();
    }
    redirectToIndex(autocompleteResult) {
        window.location.href = autocompleteResult.url;
    }
    updateLetterSections() {
        let lastSectionWithData = '';
        Object.keys(this.menuItems).forEach((letter) => {
            if (letter in this.familyData) {
                lastSectionWithData = letter;
                this.menuItems[letter] = letter;
            }
            else {
                this.menuItems[letter] = lastSectionWithData;
            }
        });
    }
}
BrowseIndexFamiliesPageComponent.ɵfac = function BrowseIndexFamiliesPageComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || BrowseIndexFamiliesPageComponent)(i0.ɵɵdirectiveInject(i0.ElementRef)); };
BrowseIndexFamiliesPageComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: BrowseIndexFamiliesPageComponent, selectors: [["ycn-browse-index-families-page"]], standalone: false, decls: 40, vars: 10, consts: [[1, "container"], [1, "page-header", "row"], [1, "page-title", "col-auto"], [1, "page-title-wrap"], [1, "d-flex"], [1, "page-name"], [1, "page-name-text"], [1, "page-header-navigation-inline"], ["href", "/indices", 1, "text-blue"], [1, "page-header-navigation-title"], [1, "page-header-navigation-title", "text-bold"], [1, "page-header-actions"], [1, "row", "visible-md-flex"], [1, "col-i-md-4", "d-flex", "align-items-end", "form-row"], [1, "flex-auto", "row", "no-gutters", "align-items-baseline"], [1, "col-auto"], [1, "form-label", "form-label-thin", "mr-1"], [1, "col"], [3, "submitHandler", "placeholder", "searchType", "buttonType", "showMoreResultsUrl"], [1, "row"], [1, "col-12"], ["ng-controller", "glossary", 1, "panel", "panel-data", "ng-scope"], [1, "panel-header"], [1, "panel-title"], [1, "bg-panel"], [1, "panel-content", "glossary-abc", "ml-auto", "mr-auto"], [4, "ngFor", "ngForOf"], [1, "panel-content"], [1, "glossary-index"], ["ng-style", "letterStyle", "routerLink", ".", 1, "ng-binding", "ng-scope", 2, "flex-basis", "calc(7.69231%)", 3, "fragment"], [1, "glossary-index-item"], [1, "glossary-index-item-title"], [1, "glossary-index-item-content"], [3, "href"]], template: function BrowseIndexFamiliesPageComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "div", 3)(4, "div", 4)(5, "div", 5)(6, "span", 6);
        i0.ɵɵtext(7, "Indices: Families");
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(8, "div", 7)(9, "a", 8)(10, "span", 9);
        i0.ɵɵtext(11, "Indices");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(12, "span");
        i0.ɵɵtext(13, "\u00A0/\u00A0");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(14, "span", 10);
        i0.ɵɵtext(15, "Families");
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(16, "div", 11)(17, "div", 12)(18, "div", 13)(19, "div", 14)(20, "div", 15)(21, "div", 16);
        i0.ɵɵtext(22, "Search All Indices");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(23, "div", 17)(24, "ycn-base-autocomplete", 18);
        i0.ɵɵlistener("submitHandler", function BrowseIndexFamiliesPageComponent_Template_ycn_base_autocomplete_submitHandler_24_listener($event) { return ctx.redirectToIndex($event); });
        i0.ɵɵelementEnd()()()()()()()();
        i0.ɵɵelementStart(25, "div", 0)(26, "div", 19)(27, "div", 20)(28, "div", 21)(29, "div", 22)(30, "h3", 23);
        i0.ɵɵtext(31, "Browse Families");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(32, "div", 24)(33, "div", 25);
        i0.ɵɵtemplate(34, BrowseIndexFamiliesPageComponent_ng_container_34_Template, 3, 2, "ng-container", 26);
        i0.ɵɵpipe(35, "keyvalue");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(36, "div", 27)(37, "div", 28);
        i0.ɵɵtemplate(38, BrowseIndexFamiliesPageComponent_ng_container_38_Template, 6, 3, "ng-container", 26);
        i0.ɵɵpipe(39, "keyvalue");
        i0.ɵɵelementEnd()()()()()();
    } if (rf & 2) {
        i0.ɵɵadvance(24);
        i0.ɵɵproperty("placeholder", "Search")("searchType", "index")("buttonType", "icon-search")("showMoreResultsUrl", true);
        i0.ɵɵadvance(10);
        i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(35, 6, ctx.menuItems));
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(39, 8, ctx.familyData));
    } }, dependencies: [i1.BaseAutocompleteComponent, i2.NgForOf, i3.RouterLink, i2.KeyValuePipe], encapsulation: 2 });
